export default 'lifecycle';
